"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DRIVER_RATING = exports.DRIVER_PREFERRED_RATING_THRESHOLD = exports.BAD_CUSTOMER_FEEDBACK_THRESHOLD = exports.RATING_GRACE_PERIOD_TRIP_TRESHOLD = exports.TRIPS_ACCESS_DRIVER_SCORE_RATING_TRESHOLD = exports.NO_FEEDBACK_REALIZED_ASSIGNATION_RATING = exports.INITIAL_DRIVER_SCORE_RATING = void 0;
// Score for driver with no feedbacks or realized assignations
exports.INITIAL_DRIVER_SCORE_RATING = 5;
// Score for realized assignation without feedback
exports.NO_FEEDBACK_REALIZED_ASSIGNATION_RATING = 5;
// Driver is able to easily get trips above this score
exports.TRIPS_ACCESS_DRIVER_SCORE_RATING_TRESHOLD = 4;
exports.RATING_GRACE_PERIOD_TRIP_TRESHOLD = 7;
exports.BAD_CUSTOMER_FEEDBACK_THRESHOLD = 4;
exports.DRIVER_PREFERRED_RATING_THRESHOLD = 4.7;
exports.MAX_DRIVER_RATING = 5;
//# sourceMappingURL=drivers.js.map